export default {
  row: {
    '& div > div:nth-child(3)': {
      textAlign: 'left'
    }
  },
  // atomic's Switch hides its checkbox by offsetting it from its text-align position
  developerSwitch: {
    textAlign: 'left'
  },
  teams: {
    marginLeft: 16,
    whiteSpace: 'nowrap'
  }
};
